import React, { useState } from "react";
import Button from "../ui/Button/Button";
import submitEddData from "../../handlers/submitEddData";
import sendEddData from "../../handlers/sendEddData";

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}

interface Props {
  enableSubmitButton: boolean;
  uploadedDocuments: any[];
  setUploadedDocuments: React.Dispatch<React.SetStateAction<any[]>>;
  enabledSectionsCount: number;
  isSendingEddData: boolean;
  formProgress: number;
}

const Footer: React.FC<Props> = ({
  enableSubmitButton,
  uploadedDocuments,
  setUploadedDocuments,
  enabledSectionsCount,
  isSendingEddData,
  formProgress,
}) => {
  const [isSubmittingEddData, setIsSubmittingEddData] =
    useState<boolean>(false);

  const handleSubmitEddData = async () => {
    setIsSubmittingEddData(true);
    let sendEddResponse = { success: true, errors: [{ text: "" }] };
    if (uploadedDocuments.length) {
      sendEddResponse = await sendEddData({
        section: "DOCUMENT",
        question: "DOCUMENT",
        files: uploadedDocuments.map(({ document_tag, encoded_string }) => ({
          document_tag,
          encoded_string,
        })),
      });
    }
    if (sendEddResponse?.success) {
      setUploadedDocuments([]);
      const submitEddResponse = await submitEddData();
      setIsSubmittingEddData(false);
      if (submitEddResponse?.success) {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              status: "completed",
              message: "Data submitted successfully",
            })
          );
        }
      } else {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              status: "error",
              message: submitEddResponse?.errors?.[0]?.text,
            })
          );
        }
      }
    } else {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            status: "error",
            message: sendEddResponse?.errors?.[0]?.text,
          })
        );
      }
    }
  };

  return (
    <footer className="bg-white border-t shadow-sm py-4 px-5 fixed bottom-0 left-0 w-full z-50">
      <div className="flex items-center justify-center max-w-md mx-auto px-4">
        <img
          src="https://images.mudrex.com/app/misc/security-extended.png"
          className="w-6 h-6 mr-[10px]"
        />
        <p className="text-sm text-gray-600">
          {`Your data is securely stored${
            isSendingEddData
              ? " • Saving.."
              : formProgress > 0
              ? " • Saved"
              : ""
          }`}
        </p>
      </div>
      <Button
        id="submit-btn"
        type="primary"
        className="w-full mt-4"
        disabled={!enableSubmitButton}
        onClick={handleSubmitEddData}
        loading={isSubmittingEddData}
      >
        Submit Details and Continue
      </Button>
    </footer>
  );
};

export default Footer;
